<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title>Reset Password</mat-card-title>
      @if (userEmail()) {
        <mat-card-subtitle>Imposta una nuova password per {{ userEmail() }}</mat-card-subtitle>
      } @else {
        <mat-card-subtitle>Imposta la tua nuova password</mat-card-subtitle>
      }
    </mat-card-header>

    <mat-card-content>
      @if (isCheckingCode()) {
        <div class="spinner-container">
          <mat-spinner diameter="40" class="spinner"></mat-spinner>
          <p class="loading-text">Verifica del codice di ripristino in corso...</p>
        </div>
      } @else if (successMessage()) {
        <div class="success-container">
          <div class="success-banner">
            {{ successMessage() }}
          </div>
          <button mat-raised-button color="primary" type="button" (click)="navigateToLogin()" class="submit-btn full-width">
            Vai al Login
          </button>
        </div>
      } @else if (!isCodeValid() && errorMessage()) {
        <div class="success-container">
          <div class="error-banner">
            {{ errorMessage() }}
          </div>
          <button mat-raised-button color="primary" type="button" (click)="navigateToLogin()" class="submit-btn full-width">
            Torna al Login
          </button>
        </div>
      } @else {
        <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="login-form">
          <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>Nuova Password</mat-label>
            <label for="password-input" class="visually-hidden">Nuova Password</label>
            <input id="password-input" matInput type="password" [type]="hidePassword() ? 'password' : 'text'" formControlName="password" autocomplete="new-password">
            <button type="button" mat-icon-button matSuffix (click)="hidePassword.set(!hidePassword())" [attr.aria-label]="hidePassword() ? 'Mostra password' : 'Nascondi password'" [attr.aria-pressed]="!hidePassword()" class="password-toggle-btn">
              <mat-icon class="password-toggle-icon">{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (resetForm.get('password')?.hasError('required') && resetForm.get('password')?.touched) {
              <mat-error>La password è obbligatoria</mat-error>
            }
            @if (resetForm.get('password')?.hasError('minlength') && resetForm.get('password')?.touched) {
              <mat-error>La password deve essere di almeno 6 caratteri</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>Conferma Nuova Password</mat-label>
            <label for="confirm-password-input" class="visually-hidden">Conferma Nuova Password</label>
            <input id="confirm-password-input" matInput type="password" [type]="hideConfirmPassword() ? 'password' : 'text'" formControlName="confirmPassword" autocomplete="new-password">
            <button type="button" mat-icon-button matSuffix (click)="hideConfirmPassword.set(!hideConfirmPassword())" [attr.aria-label]="hideConfirmPassword() ? 'Mostra password' : 'Nascondi password'" [attr.aria-pressed]="!hideConfirmPassword()" class="password-toggle-btn">
              <mat-icon class="password-toggle-icon">{{ hideConfirmPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (resetForm.get('confirmPassword')?.hasError('required') && resetForm.get('confirmPassword')?.touched) {
              <mat-error>La conferma della password è obbligatoria</mat-error>
            }
            @if (resetForm.hasError('passwordsMismatch') && resetForm.get('confirmPassword')?.touched) {
              <mat-error>Le password inserite non corrispondono</mat-error>
            }
          </mat-form-field>

          @if (errorMessage()) {
            <div class="error-banner">
              {{ errorMessage() }}
            </div>
          }

          <div class="button-row">
            <button mat-raised-button color="primary" type="submit" [disabled]="resetForm.invalid || isLoading()" class="submit-btn half-width">
              @if (isLoading()) {
                <mat-spinner diameter="20" class="spinner"></mat-spinner>
              } @else {
                Salva Password
              }
            </button>
            <button mat-button type="button" (click)="navigateToLogin()" [disabled]="isLoading()" class="cancel-btn half-width">
              Annulla
            </button>
          </div>
        </form>
      }
    </mat-card-content>
  </mat-card>
</div>
